export enum CourseStatus{
    DRAFT=1,
    PUBLISHED=2,
    RETIRED=3
}